<app-modal-frame
  [headerText]="data.edit ? CONSTANTS.EDIT_HEADER : CONSTANTS.HEADER"
  (emitExit)="close()"
>
  <div class="card-content">
    <div class="segment-container">
      <ion-segment
        class="segment"
        value="buttons"
        [disabled]="data.edit ? formDirty : true"
        [(ngModel)]="currentTab"
        (ionChange)="onTabSelected($event)"
      >
        <!-- LOCATION TAB -->
        <ion-segment-button
          class="segment-btn"
          [value]="availableTabs.LOCATION"
        >
          <ion-label>{{ CONSTANTS.LOCATION }}</ion-label>
        </ion-segment-button>
        <!------------------>

        <!-- ADDRESS TAB -->
        <ion-segment-button class="segment-btn" [value]="availableTabs.ADDRESS">
          <ion-label>{{ CONSTANTS.ADDRESS }}</ion-label>
        </ion-segment-button>
        <!------------------>

        <!-- GROUP TAB -->
        <ion-segment-button class="segment-btn" [value]="availableTabs.GROUP">
          <ion-label>{{ CONSTANTS.GROUPS }}</ion-label>
        </ion-segment-button>
        <!------------------>

        <!-- CONFIGURATION -->
        <ion-segment-button
          class="segment-btn large-btn"
          [value]="availableTabs.CONFIGURATION"
        >
          <ion-label>{{ CONSTANTS.CONFIGURATIONS }}</ion-label>
        </ion-segment-button>
        <!------------------>
      </ion-segment>
    </div>

    <!------- Card Content --------->
    <div class="content">
      @switch (currentTab) {
        @case (availableTabs.LOCATION) {
          <app-location-form
            [locationItem]="data.profile"
            [edit]="data.edit"
            (formStatus)="onFormChange($event)"
            (changeTab)="onSubmitClicked($event)"
          ></app-location-form>
        }
        @case (availableTabs.ADDRESS) {
          <app-address-form
            [locationItem]="data.profile"
            [edit]="data.edit"
            (formStatus)="onFormChange($event)"
            (changeTab)="onSubmitClicked($event)"
          ></app-address-form>
        }
        @case (availableTabs.GROUP) {
          <app-group
            [locationItem]="data.profile"
            [edit]="data.edit"
            (formStatus)="onFormChange($event)"
            (changeTab)="onSubmitClicked($event)"
          ></app-group>
        }
        @case (availableTabs.CONFIGURATION) {
          <app-configuration
            [locationItem]="data.profile"
            [edit]="data.edit"
            (formStatus)="onFormChange($event)"
            (changeTab)="onSubmitClicked($event)"
          ></app-configuration>
        }
      }
    </div>
    <!------------------>
  </div>
</app-modal-frame>
